import index from './index'
import store from '@/store'

export const get = (project, creditId, cmd) => {
    if(cmd === 'cached')
        return index.files(project, 'credit', true, false, creditId)
    
    let forceSync = cmd === 'forceSync'
    
    return index.files(project, 'credit', {
        linkedTo: 'credit',
        linkedId: creditId,
        linksInfo: 4,
        total: 500
    }, forceSync, creditId)
}

export const reset = (project, creditId) => {
    store.dispatch('files/reset', {
        type: 'credit',
        id: project.id,
        linkedId: creditId
    })
}

export default {
    get,
    reset
}
